export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO';
export const SET_USER_ACCOUNT = 'SET_USER_ACCOUNT';

export function receiveUserInfo(userInfo) {
  const groupsObj = userInfo.groups.reduce((acc, group) => {
    acc[group] = true;
    return acc;
  }, {});

  return {
    type: RECEIVE_USER_INFO,
    user: {
      id: userInfo.id,
      imgSrc: userInfo.images && userInfo.images[0] && userInfo.images[0].url,
      displayName: userInfo.display_name,
      groups: groupsObj,
      email: userInfo.email,
      account: userInfo.account,
    },
  };
}

export function setUserAccount(account) {
  return {
    type: SET_USER_ACCOUNT,
    user: {
      account,
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/user.js